import { render, staticRenderFns } from "./HomeInstitucional.vue?vue&type=template&id=5a5b2744&scoped=true&"
import script from "./HomeInstitucional.vue?vue&type=script&lang=js&"
export * from "./HomeInstitucional.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/site.css?vue&type=style&index=0&id=5a5b2744&prod&scoped=true&lang=css&"
import style1 from "./HomeInstitucional.vue?vue&type=style&index=1&id=5a5b2744&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b2744",
  null
  
)

export default component.exports